import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-cream/90 backdrop-blur-md border-b border-taupe/30 transition-all duration-300" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between" data-id="element-185">
        <div className="flex items-center" data-id="element-186">
          <span className="font-serif font-bold text-forest text-lg tracking-tight" data-id="element-187">
            Rylte Health
          </span>
        </div>
        <div className="hidden sm:flex items-center" data-id="element-188">
          <span className="text-[10px] uppercase tracking-widest text-ink/40 font-medium" data-id="element-189">
            Advertorial
          </span>
        </div>
        <div className="flex items-center" data-id="element-190">
          <a href="https://rylte.com/products/nerva" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-forest hover:text-sage transition-colors duration-200" data-id="element-191">
            Learn About Nerva™
          </a>
        </div>
      </div>
    </header>;
}